import styled from 'styled-components';

import { basicSmallTextStyle, Text } from '@dreryk/react-components';

export const StyledText = styled(Text)`
   ${basicSmallTextStyle};
`;

StyledText.displayName = 'StyledText';
